import React from 'react'
import EmployerNavbar from '../../../../components/Profile-navbar/employer-navbar'
import profile from '../../../../images/profile-3.svg'
import { Link } from 'react-router-dom'
import { FaTimes } from 'react-icons/fa'
import { Modal, Container, Row, Col} from 'react-bootstrap'

const EmployerSettings = (props) => {
  return (
    <div>
       <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Settings
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <Container>
          <Row>
            <Col xs={6} md={4} className='align-items-center justify-content-center text-center'>
              <div className='align-items-center text-center px-sm-5 py-md-5 gap-3 pic-grid'>
              <img src={profile}/>
              
              <p>Edit</p>
              </div>
            </Col>
            <Col xs={12} md={8}>
              <div className='info-grid'>
              <div className='mt-3 gap-2 info-col'>
                <h2>Name</h2>
                <h3>Cynthia Charles</h3>
                <a href='#'>Change name</a>
              </div>
              <div className='mt-3 info-col gap-2'>
                <h2>Email</h2>
                <h3>cynthia@yahoo.com</h3>
                <a href='#'>Change email</a>
              </div>
              <div className='mt-3 info-col gap-2'>
                <h2>Password</h2>
                <a href='#'>Change password</a>
              </div>
              <div className=' mt-3 info-col'>
                <h2>Themes</h2>
              </div>
              </div>
            </Col>
          </Row>

          
        </Container>
      </Modal.Body>
      
       </Modal>
    </div>
  )
}

export default EmployerSettings
